import React, { Component } from 'react';

class BlanqueoPIN extends Component {
    render() { 

        const {data,actions,tarjetaBlanqueo} = this.props;

        let tituloModal = "Blanqueo de PIN"
        let mensajeSuperior = "";
        
        if(tarjetaBlanqueo){
            mensajeSuperior = "¿Confirma el BLANQUEO de PIN de la tarjeta " + tarjetaBlanqueo.NumeroTarjeta + " del cliente " + tarjetaBlanqueo.NombreCliente + "?";
        }

        return (  
        <div className='modaConfirmadorBloqueoInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modaBlanqueoPINInteriorCuerpo'>
                <div>{mensajeSuperior}</div>
                <div>
                    <div>Nuevo N° de PIN</div>
                    <input value={data.IntegrantesCuenta.nuevoPin} maxLength={4} onChange={(e)=>actions.edicionCampoSeccion("IntegrantesCuenta","nuevoPin",e.target.value,"PIN")} placeholder= "Ingrese nuevo PIN" type="text"></input>
                    {data.IntegrantesCuenta && data.IntegrantesCuenta.validaciones.PIN == false &&<div><label className='error'> El PIN debe tener 4 dígitos</label></div> }
                </div>
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","BLANQUEO-TARJETA",false,null,"errorValidacion", true)} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>actions.modificarPinTarjeta(tarjetaBlanqueo)} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default BlanqueoPIN;